import React from 'react';
import PropTypes from 'prop-types';

const IconMapEdit = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="currentColor"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.719.279a.956.956 0 0 0-1.35.001l-.79.79 1.352 1.351.789-.789A.956.956 0 0 0 13.719.28ZM8.077 7.276l4.307-4.308-1.352-1.352-4.305 4.306-.498 1.635c-.03.1-.046.15-.033.185.01.03.034.053.064.063.034.013.084-.002.184-.033l1.633-.496Zm-6.772-5.45 3.003-.751 3.374.844a.522.522 0 0 1-.253 1.013l-2.583-.645v9.693l3.23.808V9.153a.539.539 0 1 1 1.078 0v3.632l2.692-.69V5.922a.539.539 0 1 1 1.077 0v5.655c0 .482 0 .722-.084.922-.074.177-.194.33-.348.445-.173.13-.406.189-.873.305L8.615 14l-4.307-1.077-3.238.81c-.364.09-.547.136-.69.092a.539.539 0 0 1-.302-.236C0 13.461 0 13.273 0 12.896V3.498c0-.481 0-.722.084-.922.074-.177.194-.33.347-.445.174-.13.407-.189.874-.305Zm-.228 1.156 2.692-.692v9.687l-2.692.658V2.982Z"
      clipRule="evenodd"
    />
  </svg>
);

IconMapEdit.propTypes = {
  className: PropTypes.string,
};

IconMapEdit.defaultProps = {
  className: '',
};

export default IconMapEdit;
